import React from 'react';
import { Link as Internal } from 'gatsby';

export default function Link({ activeStyle, to, ...rest }) {
  return /^\/(?!\/)/.test(to)
    ? <Internal activeStyle={activeStyle} to={to} {...rest} />
    : (
      <a
        href={to}
        rel={/^(mailto|tel)|getvela\.com/.test(to) ? undefined : 'noreferrer noopener'}
        {...rest}
      />
    );
}
